module.exports = __webpack_public_path__ + "img/font_edwardian-script-itc.790d2e0.svg";